<div class="dismissal-container" [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
    <div *ngIf="loading" class="loading">
        <mat-spinner *ngIf="true" mode="indeterminate"></mat-spinner>
    </div>
    <label (click)="openDismissalReprots()" class="dismissal-header">
        {{'student-dismissal-track.header'| translate}}
        <svg xmlns="http://www.w3.org/2000/svg" width="6.576" height="11.257" viewBox="0 0 6.576 11.257"
            [ngStyle]="{'transform': currLang == 'en' ? 'rotate(0)' :'rotate(180deg)'}">
            <g id="next_1_" data-name="next (1)" transform="translate(0.554 0.554)">
                <g id="Group_5442" data-name="Group 5442" transform="translate(0 0)">
                    <path id="Path_5603" data-name="Path 5603"
                        d="M107.651,5.354l-4.687,4.687a.391.391,0,0,1-.552-.552l4.411-4.411L102.411.667a.391.391,0,0,1,.552-.552L107.651,4.8A.391.391,0,0,1,107.651,5.354Z"
                        transform="translate(-102.297 0)" fill="#1d71d3" stroke="#1d71d3" stroke-width="1" />
                </g>
            </g>
        </svg>
    </label>
    <div class="request-section">
        <div class="parent-assistant" [routerLink]="['/reports/dismissal-tracking-log','not_requested']">
            <div class="parent">
                <span class="gray-req">{{dismissalStatistics.not_requested ? dismissalStatistics.not_requested :
                    0}}</span>
                <small>{{'student-dismissal-track.not-requested'| translate}}</small>
            </div>
        </div>
        <div class="parent-assistant" [routerLink]="['/reports/dismissal-tracking-log','pending']">
            <div class="parent">
                <span class="blue-req">{{dismissalStatistics.get_ready ? dismissalStatistics.get_ready : 0}}</span>
                <small>{{'student-dismissal-track.getting-ready'| translate}}</small>
            </div>
        </div>
        <div class="parent-assistant" [routerLink]="['/reports/dismissal-tracking-log','with_staff']">
            <div class="parent">
                <span class="blue-req">{{dismissalStatistics.with_staff ? dismissalStatistics.with_staff : 0}}</span>
                <small>{{'student-dismissal-track.student-staff'| translate}}</small>
            </div>
        </div>
        <div class="parent-assistant" [routerLink]="['/reports/dismissal-tracking-log','all_delivered']">
            <div class="parent">
                <span class="blue-req">{{dismissalStatistics.delivered ? dismissalStatistics.delivered : 0}}</span>
                <small>{{'student-dismissal-track.delivered'| translate}}</small>
            </div>
        </div>

        <div class="parent-assistant" [routerLink]="['/reports/dismissal-tracking-log','canceled']">
            <div class="parent">
                <span class="blue-req">{{dismissalStatistics.canceled ? dismissalStatistics.canceled : 0}}</span>
                <small>{{'student-dismissal-track.canceled'| translate}}</small>
            </div>
        </div>

        <div class="parent-assistant parent-assistant-grayed" >
            <div class="parent">
                <span class="blue-req">{{dismissalStatistics.self_checkout ? dismissalStatistics.self_checkout : 0}}</span>
                <small>{{'student-dismissal-track.checkout'| translate}}</small>
            </div>
        </div>
    </div>
</div>